import ApplicantForm from "./ApplicantForm"
import NaturalApplicantForm from "./NaturalApplicantForm"
import { countries } from "../../../utils/countryData"

export default function LegalApplicantForm({
  onCancel,
  onSave,
  initialValues,
}: {
  onCancel: () => void
  onSave: (data: any) => void
  initialValues?: Record<string, any>
}) {
  const isEditing = !!initialValues
  const formType = initialValues?.type || "legal"

  if (formType === "natural" && !isEditing) {
    return (
      <NaturalApplicantForm
        onCancel={onCancel}
        onSave={onSave}
        initialValues={{ ...(initialValues || {}), type: "natural" }}
      />
    )
  }

  const COMPANY_SIZES = [
    { label: "Micro", value: "Micro" },
    { label: "Small", value: "Small" },
    { label: "Medium", value: "Medium" },
    { label: "Large", value: "Large" },
  ]

  const ACTIVITY_SECTORS = [
    { label: "Agriculture, forestry and fishing", value: "A" },
    { label: "Mining and quarrying", value: "B" },
    { label: "Manufacturing", value: "C" },
    { label: "Electricity, gas, steam and air conditioning supply", value: "D" },
    { label: "Water supply; sewerage; waste management and remediation activities", value: "E" },
    { label: "Construction", value: "F" },
    { label: "Wholesale and retail trade; repair of motor vehicles and motorcycles", value: "G" },
    { label: "Transportation and storage", value: "H" },
    { label: "Accommodation and food service activities", value: "I" },
    { label: "Information and communication", value: "J" },
    { label: "Financial and insurance activities", value: "K" },
    { label: "Real estate activities", value: "L" },
    { label: "Professional, scientific and technical activities", value: "M" },
    { label: "Administrative and support service activities", value: "N" },
    { label: "Public administration and defence; compulsory social security", value: "O" },
    { label: "Education", value: "P" },
    { label: "Human health and social work activities", value: "Q" },
    { label: "Arts, entertainment and recreation", value: "R" },
    { label: "Other service activities", value: "S" },
    { label: "Activities of households as employers", value: "T" },
    { label: "Activities of extraterritorial organisations and bodies", value: "U" },
  ]

  const fields = [
    { name: "legalName", label: "Name of the legal entity", required: true },
    { name: "nationalDesignation", label: "National designation" },
    {
      name: "countryOfIncorporation",
      label: "Country of registration",
      required: true,
      options: countries,
    },
    {
      name: "companySize",
      label: "Company size",
      options: COMPANY_SIZES,
    },
    {
      name: "activitySector",
      label: "Activity sector",
      options: ACTIVITY_SECTORS,
    },
    { name: "address.street", label: "Street and house number", required: true },
    { name: "address.city", label: "City", required: true },
    { name: "address.postalCode", label: "Postal code", required: true },
    {
      name: "address.country",
      label: "Country",
      required: true,
      options: countries,
    },
    { name: "contact.phone", label: "Phone" },
    { name: "contact.email", label: "Email" },
  ]

  return (
    <ApplicantForm
      onCancel={onCancel}
      onSave={(data) => onSave({ ...data, type: "legal" })}
      fields={fields}
      initialValues={initialValues}
    />
  )
}
